import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  coin: {
    position: "fixed",
    zIndex: 112,
    height: 24,
    width: 24,
    opacity: 0,
  },
}));
